import axios from "axios";
import endpoints from "../config/endpoints";
import { IProduct } from "../models/product.model";

const getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
}
export async function postProductStatistic(product: IProduct): Promise<any> {
    const token = getCookie("apinew-token");
    //if (!token) throw new Error("Brak tokenu");

    var data = product;
    if (data.category == null){
        data.category = "";
    }

    const response = await axios.post(endpoints.stylizations.productstatistic, data, {
        withCredentials: token ? true : false,
        headers: token ? {
            Authorization: `Bearer ${token}`,
        } : {},
    });

    return response.data;
}
